import ConfigNode from 'Model/ConfigNode'
import { branch } from 'Model/constants'

class GraphColors extends ConfigNode
  @className = 'GraphColors'

  constructor: ->
    super('graphColors')

  map: ->
    @get('value')

  update: (map) ->
    @set('value', map, { dataType: 'json' })
    @save()

  reset: ->
    @update({})

  @load: ->
    super('graphColors', @)

export default GraphColors
